import { Save, UserRound } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { useAcademy } from '../context/AcademyContext'
import { useAuth } from '../context/AuthContext'

export function ProfilePage() {
  const { user, demoMode, refreshUser } = useAuth()
  const { state, updateProfile, error, clearError } = useAcademy()
  const profile = state.users.find((item) => item.id === user?.id)
  const [saved, setSaved] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSubmitting(true)
    setSaved(false)
    clearError()
    const data = new FormData(event.currentTarget)
    try {
      await updateProfile({
        name: String(data.get('name')).trim(),
        country: String(data.get('country')).trim(),
        profession: String(data.get('profession')).trim(),
        interests: String(data.get('interests')).split(',').map((value) => value.trim()).filter(Boolean),
      })
      await refreshUser()
      setSaved(true)
      window.setTimeout(() => setSaved(false), 2500)
    } catch {
      setSaved(false)
    } finally {
      setSubmitting(false)
    }
  }

  return <div className="profile-page"><header className="dashboard-heading"><div><span className="eyebrow">Mi cuenta</span><h1>Perfil profesional</h1><p>Mantén solo la información necesaria para tu participación.</p></div></header><section className="profile-card"><div className="profile-icon"><UserRound /></div><form onSubmit={(event) => void submit(event)}><label>Nombre<input name="name" defaultValue={profile?.name ?? user?.name} required minLength={2} /></label><label>Correo<input value={user?.email ?? ''} disabled /><small>Para modificarlo, contacta a la administradora.</small></label><div className="form-row"><label>País<select name="country" defaultValue={profile?.country || 'Chile'}><option>Chile</option><option>Argentina</option><option>Colombia</option><option>México</option><option>Perú</option><option>Uruguay</option><option>Otro</option></select></label><label>Profesión<input name="profession" defaultValue={profile?.profession ?? ''} /></label></div><label>Intereses profesionales<input name="interests" defaultValue={profile?.interests.join(', ') ?? ''} placeholder="Ética, confidencialidad, docencia…" /></label><div className="notice warning"><strong>No incluyas información clínica ni datos de pacientes.</strong></div>{saved && <div className="form-message success" role="status">{demoMode ? 'Perfil guardado en esta demostración.' : 'Perfil guardado correctamente.'}</div>}{error && <div className="form-message error" role="alert">{error}</div>}<button className="button" disabled={submitting}><Save /> {submitting ? 'Guardando…' : 'Guardar cambios'}</button></form></section></div>
}
